import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'web-ui-components/lib/organisms/modals';

const LoaderComponent = ({ isOpen, title, body }) => <Loader isOpen={isOpen} title={title} body={body} />;

LoaderComponent.propTypes = {
  isOpen: PropTypes.bool,
};

LoaderComponent.defaultProps = {
  title: 'This may take a few moments.',
  body: 'Please do not close your browser.',
  isOpen: false,
};

export default LoaderComponent;
